var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSliderMinusSign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8134_510579",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 14,
    width: 20,
    height: 4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 14.666H23.9998C24.7362 14.666 25.3332 15.263 25.3332 15.9993C25.3332 16.7357 24.7362 17.3327 23.9998 17.3327H7.99984C7.26346 17.3327 6.6665 16.7357 6.6665 15.9993C6.6665 15.263 7.26346 14.666 7.99984 14.666Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8134_510579)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6883 -25.3322C14.9649 -26.0692 17.0266 -26.0739 18.3111 -25.3322L50.6387 -6.66787C51.9153 -5.93085 52.9501 -4.14769 52.9501 -2.66438V34.6643C52.9501 36.1383 51.9233 37.9261 50.6387 38.6678L18.3111 57.3321C17.0346 58.0692 14.9729 58.0738 13.6883 57.3321L-18.6393 38.6678C-19.9158 37.9308 -20.9507 36.1476 -20.9507 34.6643V-2.66438C-20.9507 -4.13843 -19.9239 -5.92622 -18.6393 -6.66787L13.6883 -25.3322Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSliderMinusSign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slider-minus-sign.c70fb207bf871db29f27a56dfb1c23c2.svg";